import 'azure-maps-control/dist/atlas.min.css';

import { FC } from 'react';
import {
  AzureMap,
  AzureMapDataSourceProvider,
  AzureMapLayerProvider,
  AzureMapsProvider,
  IAzureMapOptions
} from 'react-azure-maps';

import { AzureMapCustomization } from './AzureMapCustomization';
import { useWorldMap } from './hooks/useWorldMap';
import { InteractivePopup } from './InteractivePopup';
import {
  dataSourceOptions,
  groupMarkerSymbolLayerOptions,
  groupNumberSymbolLayerOptions
} from './WorldMap.constants';
import { ExternalMapPoint, PopupRenderer } from './WorldMap.types';

export interface WorldMapProps {
  autoCenter?: boolean;
  id: string;
  options?: IAzureMapOptions;
  points?: ExternalMapPoint[];
  popupRenderer?: PopupRenderer;
}

export const WorldMap: FC<WorldMapProps> = ({
  autoCenter,
  id,
  options,
  points,
  popupRenderer
}) => {
  
  const {
    azureMapControls,
    azureMapOptions,
    bubblesLayerEvents,
    cameraOptions,
    closePopup,
    dataSourceCollection,
    isAuthReady,
    pinMarkerSymbolLayerOptions,
    pinsLayerEvents,
    popupData: { isVisible, position, properties }
  } = useWorldMap({
    autoCenter,
    options,
    points
  });

  const popupOptions = {
    draggable: false,
    position
  };

  if (!isAuthReady || !cameraOptions.center) {
    return null;
  }

  return (
    <AzureMapsProvider>
      <AzureMapCustomization>
        <AzureMap
          cameraOptions={cameraOptions}
          controls={azureMapControls}
          options={azureMapOptions}
        >
          <AzureMapDataSourceProvider
            collection={dataSourceCollection}
            id={`world-map-data-source-provider-${id}`}
            options={dataSourceOptions}
          >
            <AzureMapLayerProvider
              events={bubblesLayerEvents}
              options={groupMarkerSymbolLayerOptions}
              type='SymbolLayer'
            />
            <AzureMapLayerProvider
              events={bubblesLayerEvents}
              options={groupNumberSymbolLayerOptions}
              type='SymbolLayer'
            />
            <AzureMapLayerProvider
              events={pinsLayerEvents}
              options={pinMarkerSymbolLayerOptions}
              type='SymbolLayer'
            />
            <InteractivePopup
              isVisible={isVisible}
              options={popupOptions}
            >
              {isVisible && popupRenderer && properties ? popupRenderer(properties, closePopup) : null}
            </InteractivePopup>
          </AzureMapDataSourceProvider>
        </AzureMap>
      </AzureMapCustomization>
    </AzureMapsProvider>
  );
};
